// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as getFormListReducer } from './getFormList';
import { reducer as submitFormReducer } from './submitForm';
import { reducer as deleteFormReducer } from './deleteForm';
import { reducer as formModalChangeReducer } from './formModalChange';
import { reducer as chooseCurrentFormReducer } from './chooseCurrentForm';
import { reducer as getFormAttrListReducer } from './getFormAttrList';
import { reducer as submitFormAttrReducer } from './submitFormAttr';
import { reducer as deleteFormAttrReducer } from './deleteFormAttr';
import { reducer as formAttrModalChangeReducer } from './formAttrModalChange';
import { reducer as chooseCurrentFormAttrReducer } from './chooseCurrentFormAttr';
import { reducer as getFormSubmitListReducer } from './getFormSubmitList';
import { reducer as submitFormSubmitReducer } from './submitFormSubmit';
import { reducer as deleteFormSubmitReducer } from './deleteFormSubmit';
import { reducer as formSubmitModalChangeReducer } from './formSubmitModalChange';
import { reducer as chooseCurrentFormSubmitReducer } from './chooseCurrentFormSubmit';

const reducers = [
  getFormSubmitListReducer,
  submitFormSubmitReducer,
  deleteFormSubmitReducer,
  formSubmitModalChangeReducer,
  chooseCurrentFormSubmitReducer,
  getFormAttrListReducer,
  submitFormAttrReducer,
  deleteFormAttrReducer,
  formAttrModalChangeReducer,
  chooseCurrentFormAttrReducer,
  getFormListReducer,
  submitFormReducer,
  deleteFormReducer,
  formModalChangeReducer,
  chooseCurrentFormReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/formedit/redux/reducer.js